import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ButtonIconStyled, ButtonMainStyled } from './ButtonMain.styles';

/** Most used button */
export const ButtonMain = ({
  expressionId,
  onClick,
  isOneLineName,
  icon,
  buttonRef,
  ...rest
}) => {
  return (
    <ButtonMainStyled
      ref={buttonRef}
      onClick={onClick}
      isOneLineName={isOneLineName}
      hasIcon={!!icon}
      {...rest}
    >
      {!!expressionId && <FormattedMessage id={expressionId} />}
      {icon && <ButtonIconStyled icon={icon} />}
    </ButtonMainStyled>
  );
};

ButtonMain.propTypes = {
  expressionId: PropTypes.string,
  onClick: PropTypes.func,
  isOneLineName: PropTypes.bool,
  icon: PropTypes.string,
  buttonRef: PropTypes.func,
};
